export default __webpack_public_path__ + "static/077-11aaa75aecda32539764722883fc0afe.jpg";